module.exports = __webpack_public_path__ + "img/fx.979029d4.svg";